import React from 'react';
import { PeriodicReportingType } from '../PeriodicReporting';
import PeriodicReportingUpdateModal from './PeriodicReportingUpdateModal';
import PeriodicReportingDeleteModal from './PeriodicReportingDeleteModal';

interface PeriodicReportingActionCellProps {
	data: PeriodicReportingType;
	fetchData: () => void;
	fetchTotals?: () => void;
	state: 'DRAFT' | 'VALIDATED';
	isEnabledToView: boolean;
	isProjectWp: boolean;
	userCompanies?: number[];
	projectIndirectCostsPerc: number;
}

const PeriodicReportingActionCell: React.FC<PeriodicReportingActionCellProps> = ({
	data,
	fetchData,
	fetchTotals,
	state,
	isEnabledToView,
	isProjectWp,
	userCompanies,
	projectIndirectCostsPerc,
}) => {
	return (
		<div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
			<PeriodicReportingUpdateModal
				data={data}
				fetchData={fetchData}
				fetchTotals={fetchTotals}
				state={state}
				isEnabledToView={isEnabledToView}
				isProjectWp={isProjectWp}
				projectIndirectCostsPerc={projectIndirectCostsPerc}
			/>
			{state === 'DRAFT' && !isEnabledToView ? <PeriodicReportingDeleteModal data={data} fetchData={fetchData} /> : null}
		</div>
	);
};

export default PeriodicReportingActionCell;
